import type {
  Maybe,
  Podcast,
  PodcastDefaultContentTemplateDynamicZone,
} from "../generated/graphql";

const RELATED_BLOCK_TYPENAME = "ComponentPodcastPodcastRelated";

function isPodcastRelatedBlock(
  c: Maybe<PodcastDefaultContentTemplateDynamicZone> | null,
): c is Extract<
  PodcastDefaultContentTemplateDynamicZone,
  { __typename: "ComponentPodcastPodcastRelated" }
> {
  return (
    (c as { __typename?: string } | null)?.__typename === RELATED_BLOCK_TYPENAME
  );
}

export function getRelatedPodcastsFromContent(
  content: Maybe<PodcastDefaultContentTemplateDynamicZone>[] | null | undefined,
): Podcast[] {
  const items = content ?? [];
  if (!items.length) return [];
  const relatedBlock = items.find(isPodcastRelatedBlock);
  if (!relatedBlock || !isPodcastRelatedBlock(relatedBlock)) return [];
  const connection = (
    relatedBlock as { podcasts?: { nodes?: Maybe<Podcast>[] } }
  ).podcasts;
  const nodes = connection?.nodes;
  if (!nodes?.length) return [];
  return nodes.filter((p): p is Podcast => p != null);
}

export function getContentWithoutRelatedBlock(
  content: Maybe<PodcastDefaultContentTemplateDynamicZone>[] | null | undefined,
): Maybe<PodcastDefaultContentTemplateDynamicZone>[] {
  const items = content ?? [];
  if (!items.length) return [];
  return items.filter(
    (c) =>
      (c as { __typename?: string })?.__typename !== RELATED_BLOCK_TYPENAME,
  );
}
